import React from 'react';
import { getResponsiveValue } from '../../utils/commonFun';

export function CustomSpacer({ props, formClientWidth }) {
    const isMobile = formClientWidth <= 480;
    const style = {
      height: getResponsiveValue(props?.height, props?.mobileHeight, isMobile) ?? 16,
    };
    return <div style={style} />;
}
